var map = {
	"./Button/docs.json": "./src/modules/Core/sub-modules/ui-kit/components/Button/docs.json",
	"./Card/ExpandableCard/docs.json": "./src/modules/Core/sub-modules/ui-kit/components/Card/ExpandableCard/docs.json",
	"./Card/docs.json": "./src/modules/Core/sub-modules/ui-kit/components/Card/docs.json",
	"./Date/docs.json": "./src/modules/Core/sub-modules/ui-kit/components/Date/docs.json",
	"./DrawerDialogue/docs.json": "./src/modules/Core/sub-modules/ui-kit/components/DrawerDialogue/docs.json",
	"./Features/docs.json": "./src/modules/Core/sub-modules/ui-kit/components/Features/docs.json",
	"./Loader/docs.json": "./src/modules/Core/sub-modules/ui-kit/components/Loader/docs.json",
	"./Stamp/docs.json": "./src/modules/Core/sub-modules/ui-kit/components/Stamp/docs.json",
	"modules/Core/sub-modules/ui-kit/components/Button/docs.json": "./src/modules/Core/sub-modules/ui-kit/components/Button/docs.json",
	"modules/Core/sub-modules/ui-kit/components/Card/ExpandableCard/docs.json": "./src/modules/Core/sub-modules/ui-kit/components/Card/ExpandableCard/docs.json",
	"modules/Core/sub-modules/ui-kit/components/Card/docs.json": "./src/modules/Core/sub-modules/ui-kit/components/Card/docs.json",
	"modules/Core/sub-modules/ui-kit/components/Date/docs.json": "./src/modules/Core/sub-modules/ui-kit/components/Date/docs.json",
	"modules/Core/sub-modules/ui-kit/components/DrawerDialogue/docs.json": "./src/modules/Core/sub-modules/ui-kit/components/DrawerDialogue/docs.json",
	"modules/Core/sub-modules/ui-kit/components/Features/docs.json": "./src/modules/Core/sub-modules/ui-kit/components/Features/docs.json",
	"modules/Core/sub-modules/ui-kit/components/Loader/docs.json": "./src/modules/Core/sub-modules/ui-kit/components/Loader/docs.json",
	"modules/Core/sub-modules/ui-kit/components/Stamp/docs.json": "./src/modules/Core/sub-modules/ui-kit/components/Stamp/docs.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/modules/Core/sub-modules/ui-kit/components sync recursive docs\\.json$";